import { Construction, Hourglass } from "lucide-react";

export function EmImplementacao() {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <Construction className="h-16 w-16 text-orange-500 mb-4" />
      <h1 className="text-2xl font-bold mb-2">Em implementação</h1>
      <p className="text-muted-foreground mb-6">
        Esta página está em desenvolvimento. Por favor, aguarde as próximas atualizações!
      </p>
      <Hourglass className="h-8 w-8 text-muted-foreground" />
      <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
    </div>
  );
}
export default EmImplementacao;